module.exports = __webpack_public_path__ + "static/media/withdraw.f1b42707.png";